export class TransportAlreadyStartedError extends Error {
    constructor() {
        super('Transport has already been started');
    }
}
export class InvalidResponseError extends Error {
    constructor() {
        super('Invalid response received');
    }
}
//# sourceMappingURL=public-types.js.map